document.addEventListener('DOMContentLoaded', () => {
  /**
   * Lenis smooth scrolling
   */
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical',
    gestureDirection: 'vertical',
    smooth: true,
    lerp: 0.15,
    smooth: 2,
    mouseMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  // GSAP and ScrollTrigger are now loaded and ready to use
  gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
  gsap.registerPlugin(SplitText);

  /**
   * Image Animation
    */
  const slideImages = document.querySelectorAll('.slide .slide__image');
  if(slideImages.length > 0) return;
  slideImages && slideImages.forEach((imageContainer) => {
    const image = imageContainer.querySelector('img');

    gsap.to(image, {
        xPercent: 100,
        ease: "none",
        scrollTrigger: {
            trigger: imageContainer,
            start: "top bottom",
            end: "bottom top",
            scrub: true
        }
    });
  });

  /*
    **
    ** Animation Desktop
    **
    */
    document.querySelectorAll(".sticky-menu .anchor-item")[0].classList.add('active');
    if (window.innerWidth > 980) {
        const anchorLinks = document.querySelectorAll(".anchor-item");
        const horizontalSection = document.querySelector('.horizontal-scroll');
        const slidesContainer = document.querySelector('.horizontal-scroll__container');
        const menuItems = document.querySelectorAll('.menu-item');
        const scrollContainer = document.querySelector(".horizontal-scroll__container");

        // Anchor scrolling functionality
        document.querySelectorAll(".anchor-item").forEach((element, index) => {
            element.addEventListener('click', function (e) {
                e.preventDefault(); // Prevent default anchor behavior
        
                const id = this.getAttribute('href').split('#')[1]; // Get the ID from the href
                const targetElement = document.getElementById(id); // Get the target element
                
                if (targetElement) {
                    document.querySelectorAll(".sticky-menu .anchor-item")[0].classList.remove('active');
                    e.currentTarget.classList.add('active');
                    // let scrollPos = targetElement.offsetLeft + (window.innerWidth - 200);
                    // if(id === 'slide1') {
                    //     scrollPos = targetElement.offsetLeft;
                    // }
                    // lenis.scrollTo(scrollPos, {
                    //     duration: 2,
                    //     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                    //     offset: 100
                    // });
                    //Offset logic with multiple viewport width breakpoints
                    const viewportWidth = window.innerWidth;
                    let additionalOffset;

                    if (viewportWidth > 2100) {
                        additionalOffset = index === 0 ? viewportWidth * 0.35 :  
                                         index === 1 ? viewportWidth * 0.02 :     
                                         viewportWidth * -0.12 * index;           
                    } 
                    else if (viewportWidth > 1800) {
                        additionalOffset = index === 0 ? viewportWidth * 0.4 :    
                                         index === 1 ? viewportWidth * 0.05 :     
                                         viewportWidth * -0.1 * index;          
                    } 
                    else {
                        additionalOffset = index === 0 ? viewportWidth * 0.5 :    
                                         index === 1 ? viewportWidth * 0.09 :    
                                         viewportWidth * -0.08 * index;         
                    }
        
                    // Get navbar height
                    const navBar = document.querySelector('.sticky-menu'); // Get the navbar
                    const navHeight = navBar ? navBar.offsetHeight : 0; // Navbar height
        
                    // Calculate the position to scroll to
                    const scrollToHere = 
                        (targetElement.offsetLeft - navHeight) * 
                        (scrollContainer.scrollWidth / (scrollContainer.scrollWidth - window.innerWidth)) + 
                        additionalOffset; // Add the additional offset
        
                    // Use GSAP to scroll to the calculated position
                    // gsap.to(window, {
                    //     scrollTo: scrollToHere,
                    //     duration: 1.6, // Duration of the scroll
                    //     ease: "power1.inOut" // Easing function
                    // });
                    let scrollPos = targetElement.offsetLeft + (window.innerWidth - 200);
                    if(id === 'slide1') {
                        scrollPos = scrollToHere;
                    }
                    lenis.scrollTo(scrollPos, {
                        duration: 2,
                        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                        offset: 100
                    });
                }
            });
        });
        

        // Function to update active class based on scroll position
        function updateActiveClass() {
            const sections = document.querySelectorAll('.horizontal-scroll__container div'); // Select all sections
            const scrollPosition = window.scrollY + window.innerHeight / 2; // Get the current scroll position

            document.querySelectorAll(`.anchor-item`)[0].classList.remove('active');
            sections.forEach(section => {
                const sectionTop = section.offsetLeft; // Get the top position of the section
                const sectionBottom = sectionTop + section.offsetWidth; // Get the bottom position of the section

                const anchorLink = document.querySelector(`.anchor-item[href="#${section.id}"]`); // Find the corresponding anchor link

                // Check if anchorLink exists before accessing classList
                if (anchorLink) {
                    if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                        if(section.id != 'slide1') {
                            if(document.querySelectorAll(`.sticky-menu .anchor-item`)[0].classList.contains('active')) {
                                document.querySelectorAll(`.sticky-menu .anchor-item`)[0].classList.remove('active')
                            } 
                        } else {
                            document.querySelectorAll(`.sticky-menu .anchor-item`)[0].classList.add('active')
                        }
                        // If the section is in view, add the active class
                        anchorLink.classList.add('active');
                    } else {
                        // Otherwise, remove the active class
                        anchorLink.classList.remove('active');
                    }
                }
            });
        }


        // Call updateActiveClass on scroll
        window.addEventListener('scroll', updateActiveClass);

        function initHorizontalScroll() {
            if (window.innerWidth > 980) {
                // Function to update heights
                function updateHeights() {
                    const navbarHeight = document.querySelector('.js-header-sticky').offsetHeight;
                    const height = window.innerHeight;
                    horizontalSection.style.height = `${height}px`;
                    // horizontalSection.style.marginTop = `${navbarHeight}px`;  // Add this line
                    gsap.utils.toArray('.slides-container > section').forEach(slide => {
                        slide.style.height = `${height}px`;
                    });
                }

                // Initial height set
                updateHeights();

                // Update heights on window resize
                window.addEventListener('resize', updateHeights);
                window.addEventListener('resize', getTotalWidth);

                function getTotalWidth() {
                    let totalWidth = 0;
                    gsap.utils.toArray('.horizontal-scroll__container div > section').forEach(slide => {
                        const styles = window.getComputedStyle(slide);
                        const width = slide.offsetWidth;
                        const marginLeft = parseFloat(styles.marginLeft);
                        const marginRight = parseFloat(styles.marginRight);
                        totalWidth += width + marginLeft + marginRight;
                    });
                    return totalWidth;
                }

                // Set the width of the slides container
                slidesContainer.style.width = `${getTotalWidth()}px`;



                if (window.innerWidth > 2100) {
                    scrollTween = gsap.to(slidesContainer, {
                        x: () => -(getTotalWidth() - (window.innerWidth / 2)),
                        ease: "none",
                        scrollTrigger: {
                            trigger: horizontalSection,
                            start: "top top",
                            end: () => `+=${getTotalWidth()}`,
                            scrub: 1,
                            pin: true,
                            anticipatePin: 1,
                            invalidateOnRefresh: true,
                        }
                    });
                } 


                else if (window.innerWidth > 1800) {
                    scrollTween = gsap.to(slidesContainer, {
                        x: () => -(getTotalWidth() - (window.innerWidth / 3)),
                        ease: "none",
                        scrollTrigger: {
                            trigger: horizontalSection,
                            start: "top top",
                            end: () => `+=${getTotalWidth()}`,
                            scrub: 1,
                            pin: true,
                            anticipatePin: 1,
                            invalidateOnRefresh: true,
                        }
                    });
                } 

                else if (window.innerWidth > 1480) {
                    scrollTween = gsap.to(slidesContainer, {
                        x: () => -(getTotalWidth() - (window.innerWidth / 4)),
                        ease: "none",
                        scrollTrigger: {
                            trigger: horizontalSection,
                            start: "top top",
                            end: () => `+=${getTotalWidth()}`,
                            scrub: 1,
                            pin: true,
                            anticipatePin: 1,
                            invalidateOnRefresh: true,
                        }
                    });
                }
                else {
                    scrollTween = gsap.to(slidesContainer, {
                        x: () => -(getTotalWidth()),
                        ease: "none",
                        scrollTrigger: {
                            trigger: horizontalSection,
                            start: "top top",
                            end: () => `+=${getTotalWidth()}`,
                            scrub: 1,
                            pin: true,
                            anticipatePin: 1,
                            invalidateOnRefresh: true,
                        }
                    });
                }

                // Prevent default vertical scrolling while in the horizontal section
                horizontalSection.addEventListener('wheel', (e) => {
                    if (ScrollTrigger.isInViewport(horizontalSection)) {
                        e.preventDefault();
                        let delta = e.deltaY;
                        // window.scrollBy(delta, 0);
                    }
                }, { passive: false });

                setupAnimations();
                setupBackgroundAnimation();
                ScrollTrigger.refresh();
            }
        }

          // Debounce function for resize events
          const debounce = (func, delay) => {
            let timeout;
            return function(...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), delay);
            };
        };

        // Use the debounced function for resize
        window.addEventListener('resize', debounce(() => {
            ScrollTrigger.getAll().forEach(st => st.kill());
            initHorizontalScroll();
        }, 200));


        // Update active class based on scroll position
        ScrollTrigger.create({
            trigger: document.querySelector('.horizontal-scroll__container'), // Trigger based on the parent of slides
            start: "top top", // Start when the top of the first slide hits the top of the viewport
            end: "bottom bottom", // End when the bottom of the last slide hits the bottom of the viewport
            onUpdate: (self) => {
                const progress = self.progress; // Get the progress of the scroll
                const currentIndex = Math.floor(progress * menuItems.length); // Calculate the current slide index

                // Remove active class from all menu items
                menuItems.forEach(item => item.classList.remove('active'));

                // Add active class to the current menu item
                if (menuItems[currentIndex]) {
                    menuItems[currentIndex].classList.add('active');
                }
            }
        });

        // Initial call
        initHorizontalScroll();

    }

    /*
    **
    ** Animation Mobile
    **
    */

    if (window.innerWidth < 980) {
        const stickyMenu = document.querySelector('.sticky-menu');
    
        if (stickyMenu) {
            // Update sticky menu position
            function updateStickyMenuPosition() {
                const menuHeight = stickyMenu.offsetHeight;
                stickyMenu.style.top = `calc(100dvh - ${menuHeight}px)`;
            }
    
            // Smooth scrolling to anchor
            function scrollToAnchor(anchorId) {
                const targetElement = document.getElementById(anchorId);
                if (targetElement) {
                    lenis.scrollTo(targetElement, {
                        duration: 2,
                        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                        offset: 100
                    });
                }
            }
    
            // Function to update active class based on scroll position
            function updateActiveClass() {
                const sections = document.querySelectorAll('div[id]');
                const scrollPosition = window.scrollY;
                const windowHeight = window.innerHeight;
                const middleScreen = scrollPosition + (windowHeight / 2);
                const offset = -600; // Offset fixe de 300px
                
                sections.forEach(section => {
                    const sectionTop = section.offsetTop;
                    const sectionBottom = sectionTop + section.offsetHeight;
                    const anchorLink = document.querySelector(`.anchor-item[href="#${section.id}"]`);

                    if (anchorLink) {
                        // Vérifie si le milieu de l'écran est dans la section avec l'offset
                        if ((middleScreen + offset) >= sectionTop && (middleScreen + offset) < sectionBottom) {
                            document.querySelectorAll('.anchor-item').forEach(item => item.classList.remove('active'));
                            anchorLink.classList.add('active');
                            if(section.id != 'slide1') {
                                if(document.querySelectorAll(`.sticky-menu .anchor-item`)[0].classList.contains('active')) {
                                    document.querySelectorAll(`.sticky-menu .anchor-item`)[0].classList.remove('active')
                                } 
                            } else {
                                document.querySelectorAll(`.sticky-menu .anchor-item`)[0].classList.add('active')
                            }
                        }
                    }
                });

                // Gestion de la dernière section
                const documentHeight = document.body.scrollHeight;
                if (scrollPosition + windowHeight >= documentHeight - 10) {
                    document.querySelectorAll('.anchor-item').forEach(item => item.classList.remove('active'));
                    const lastSection = sections[sections.length - 1];
                    const lastAnchor = document.querySelector(`.anchor-item[href="#${lastSection.id}"]`);
                    if (lastAnchor) lastAnchor.classList.add('active');
                }
            }
    
            window.addEventListener('scroll', () => {
                window.requestAnimationFrame(() => {
                    updateActiveClass();
                });

            });
    
            // Handle anchor clicks
            document.querySelectorAll(".anchor-item").forEach(element => {
                element.addEventListener('click', function (e) {
                    e.preventDefault();
                    const id = this.getAttribute('href').split('#')[1];
                    scrollToAnchor(id);
                });
            });
    
            // Initialization
            updateActiveClass();
            updateStickyMenuPosition();
    
            // Handle resize
            let resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    updateStickyMenuPosition();
                    updateActiveClass();
                }, 200);
            });
    
            setupMobileAnimations();
            setupBackgroundAnimation();
            ScrollTrigger.refresh();
        }
    }
});





/*
**
** Animation Background Color
**
*/

function setupBackgroundAnimation() {
    const colorTransition = document.querySelector('.color-transition-section');

    if (colorTransition) {
        // Créez l'animation
        gsap.to(colorTransition, {
            scrollTrigger: {
                trigger: colorTransition,
                start: 'top bottom',
                end: 'bottom center',
                scrub: true,
                markers: false, // Affiche les marqueurs pour déboguer
            },
            backgroundColor: '#01558C',
        });
    }  
}





/*
**
** Animation Desktop
**
*/

function setupAnimations() {


   // Sélectionner la slide displacement et les éléments nécessaires
    const displacementSlide = document.querySelector('.displacement-slide');
    const displacementElement = document.querySelector('.displacement-slide .displacement');
    const imageElement = displacementSlide.querySelector('.img-displacement');

    // Obtenir les dimensions de l'image
    const imageBounds = imageElement.getBoundingClientRect();
    const maxRadius = Math.min(imageBounds.width, imageBounds.height) / 2.5; // Rayon maximal basé sur la plus petite dimension

    // Créer l'animation GSAP avec une limite dynamique pour r
    if(displacementElement) {
        gsap.fromTo(
            displacementElement,
            {
                attr: { r: 0 }, // Rayon initial
            },
            {
                attr: { r: maxRadius },
                ease: 'power3.inOut',
                duration: 2,
                scrollTrigger: {
                    trigger: displacementSlide,
                    containerAnimation: scrollTween,
                    start: "left-=70% left", 
                    end: "center left",
                    markers: false, 
                    scrub: true,
                    // onEnter: () => {
                    //     gsap.to(displacementElement, {
                    //         attr: { r: maxRadius }, // Appliquer le rayon calculé
                    //         duration: 2,
                    //         ease: 'power3.inOut',
                    //     });
                    // },
                    // onLeave: () => {
                    //     gsap.to(displacementElement, {
                    //         attr: { r: 0 }, // Revenir au rayon initial
                    //         duration: 2,
                    //         ease: 'power3.inOut',
                    //     });
                    // },
                    // onEnterBack: () => {
                    //     gsap.to(displacementElement, {
                    //         attr: { r: maxRadius }, // Réappliquer le rayon calculé
                    //         duration: 2,
                    //         ease: 'power3.inOut',
                    //     });
                    // },
                    // onLeaveBack: () => {
                    //     gsap.to(displacementElement, {
                    //         attr: { r: 0 }, // Revenir au rayon initial
                    //         duration: 2,
                    //         ease: 'power3.inOut',
                    //     });
                    // }
                }
            }
        );
    }




    const anchorItems = document.querySelectorAll('.sticky-menu li');
    const anchorContainer = document.querySelectorAll('.sticky-menu');
    if(anchorItems) {
        const stickyEnter = () => {
            gsap.from(anchorContainer, {
                scale: 0.8,
                y: "-100%",
                opacity: 0,
                duration: 0.5,
                ease: "power4.out"
            });
            gsap.to(anchorContainer, {
                y: 0, 
                opacity: 1,
                duration: 0.5,
                scale: 1,
                stagger: 0.09,
                ease: "power4.out"
            });
            gsap.from(anchorItems, {
                scale: 0.8,
                y: "-100%",
                opacity: 0,
                duration: 0.5,
                delay: .2,
                ease: "power4.out"
            });
            gsap.to(anchorItems, {
                y: 0, 
                opacity: 1,
                duration: 0.5,
                scale: 1,
                stagger: 0.09,
                delay: .2,
                ease: "power4.out"
            });
        }
        const stickyLeave = () => {
            gsap.from(anchorContainer, {
                y: 0,
                opacity: 1, 
                duration: 0.5,
                scale: 1,
                stagger: 0.09,
                ease: "power4.out" 
            });
            gsap.to(anchorContainer, {
                scale: 0.8,
                y: "-100%", 
                opacity: 0, 
                duration: 0.5,
                ease: "power4.out" 
            });
            gsap.from(anchorItems, {
                y: 0,
                opacity: 1, 
                duration: 0.5,
                scale: 1,
                stagger: 0.09,
                delay: .2,
                ease: "power4.out" 
            });
            gsap.to(anchorItems, {
                scale: 0.8,
                y: "-100%", 
                opacity: 0, 
                duration: 0.5,
                delay: .2,
                ease: "power4.out" 
            });
        }
        let panel_tl = gsap.timeline({
            scrollTrigger: {
                trigger: document.querySelector('.timeline'),
                start: "top+=100px center", 
                end: "bottom-=20px bottom",
                markers: false,
                onEnter: () => {
                    stickyEnter();
                },
                onEnterBack: () => {
                    stickyEnter();
                },
                onLeave: () => {
                    stickyLeave();
                },
                onLeaveBack: () => {
                    stickyLeave();
                }
            }
        })
        panel_tl.fromTo(anchorItems,
            {
                y: '-100%',
                scale: 0.8,
                opacity: 0, // Commencer avec une opacité de 0
                duration: 0.5, // Durée de l'animation
            },
            {
                y: 0, // Finir à la position d'origine
                opacity: 1, // Finir avec une opacité de 1
                scale: 1,
                duration: 0.5, // Durée de l'animation
                stagger: 0.09, // Décalage entre chaque élément
                ease: "power4.out", // Smooth transition back
            }
        );
        panel_tl.fromTo(anchorContainer,
            {
                y: '-100%',
                scale: 0.8,
                opacity: 0, // Commencer avec une opacité de 0
                duration: 0.5, // Durée de l'animation
            },
            {
                y: 0, // Finir à la position d'origine
                opacity: 1, // Finir avec une opacité de 1
                scale: 1,
                duration: 0.5, // Durée de l'animation
                stagger: 0.09, // Décalage entre chaque élément
                ease: "power4.out", // Smooth transition back
            }
        );
    }

    gsap.utils.toArray('.animate-slide').forEach((slide, index) => {

        const title = slide.querySelector('.slide__title');
        const textElement = slide.querySelector('.slide__text');
        const textDateElements = slide.querySelectorAll('.date-slide__text');
        const dash = slide.querySelector('.slide__dash');


        // Sélectionnez tous les titres des slides
        const slideTitles = document.querySelectorAll('.slide__title');

        // Appliquer Splitting.js et créer une animation pour chaque titre
        slideTitles.forEach((title) => {
            // Diviser le texte par mots avec Splitting.js
            Splitting({ target: title, by: 'words' });

            // Récupérer tous les mots générés par Splitting.js
            const words = title.querySelectorAll('span.word'); // Splitting.js utilise `span.word` pour les mots

            // Créer une animation GSAP pour les mots
            const animation = gsap.fromTo(
                words,
                { y: '100%', opacity: 0, rotate: 5 }, // État initial
                {
                    y: '0%',
                    opacity: 1,
                    rotate: 0,
                    stagger: 0.03,
                    duration: 1.35, // Réduit la durée pour fluidifier
                    ease: 'power4.out',
                    paused: true // Met l'animation en pause par défaut
                }
            );

            // Associer une animation ScrollTrigger à chaque titre
            ScrollTrigger.create({
                trigger: title, // Attache à ce titre
                start: "center right", // Animation commence quand le titre atteint le centre
                end: "center left", // Animation se termine après la sortie du centre
                containerAnimation: scrollTween, // Conteneur d'animation pour gérer le scroll global
                markers: false, // Debug markers pour tester les zones
                onEnter: () => animation.play(), // Joue l'animation quand le titre entre
                onLeave: () => animation.reverse(), // Rejoue l'animation à l'envers quand il sort
                onEnterBack: () => animation.play(), // Rejoue dans l'autre sens
                onLeaveBack: () => animation.reverse(), // Réinverse dans l'autre sens
            });
        });

    
    
        // Text description animation
        if (textElement) {
            gsap.fromTo(textElement,
                { opacity: 0, y: 20 }, // Starting state
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.95,
                    ease: 'expo.out',
                    scrollTrigger: {
                        trigger: textElement,
                        containerAnimation: scrollTween,
                        start: "left+=40% right",
                        end: "right-=10% left",
                        markers: false,
                        onEnter: () => gsap.to(textElement, {
                            opacity: 1,
                            y: 0,
                            duration: 0.95,
                            ease: 'expo.out',
                        }),
                        onLeave: () => gsap.to(textElement, {
                            opacity: 0,
                            y: 20,
                            duration: 0.95,
                            ease: 'expo.out',
                        }),
                        onEnterBack: () => gsap.to(textElement, {
                            opacity: 1,
                            y: 0,
                            duration: 0.95,
                            ease: 'expo.out',
                        }),
                        onLeaveBack: () => gsap.to(textElement, {
                            opacity: 0,
                            y: 20,
                            duration: 0.95,
                            ease: 'expo.out',
                        })
                    }
                }
            );
            
        }

        // Animation for date-slide text lines
        textDateElements.forEach((textDateElement, index) => {
            gsap.fromTo(textDateElement,
                { opacity: 0, y: 20 }, // Starting state
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.95,
                    ease: 'power4.out',
                    scrollTrigger: {
                        trigger: textDateElement,
                        containerAnimation: scrollTween,
                        start: "left+=40% right",
                        end: "right-=10% left",
                        markers: false,
                        onEnter: () => gsap.to(textDateElement, {
                            opacity: 1,
                            y: 0,
                            duration: 0.95,
                            ease: 'power4.out',
                        }),
                        onLeave: () => gsap.to(textDateElement, {
                            opacity: 0,
                            y: 20,
                            duration: 0.95,
                            ease: 'power4.out',
                        }),
                        onEnterBack: () => gsap.to(textDateElement, {
                            opacity: 1,
                            y: 0,
                            duration: 0.95,
                            ease: 'power4.out',
                        }),
                        onLeaveBack: () => gsap.to(textDateElement, {
                            opacity: 0,
                            y: 20,
                            duration: 0.95,
                            ease: 'power4.out',
                        })
                    }
                }
            );
        });

        // Dash animation
        if (dash) {
            gsap.fromTo(dash,
                { width: 0 }, // Starting state
                {
                    width: "50px",
                    duration: 1,
                    ease: "power4.out",
                    scrollTrigger: {
                        trigger: dash,
                        containerAnimation: scrollTween,
                        start: "left+=40% right",
                        end: "right-=10% left",
                        markers: false,
                        onEnter: () => gsap.to(dash, {
                            width: "50px",
                            duration: 1,
                            ease: "power4.out",
                        }),
                        onLeave: () => gsap.to(dash, {
                            width: 0,
                            duration: 1,
                            ease: "power4.out",
                        }),
                        onEnterBack: () => gsap.to(dash, {
                            width: "50px",
                            duration: 1,
                            ease: "power4.out",
                        }),
                        onLeaveBack: () => gsap.to(dash, {
                            width: 0,
                            duration: 1,
                            ease: "power4.out",
                        })
                    }
                }
            );
        }


        // Parallax effect for images (except revolution slide)
        if (!slide.classList.contains('slide--revolution')) {
            const imageInner = slide.querySelector('.slide__image-inner');
            if (imageInner) {
                gsap.fromTo(imageInner,
                    {
                        x: -200,
                        scale: 1,
                    },
                    {
                        x: +200,
                        scale: 1.2,
                        ease: "none",
                        scrollTrigger: {
                            trigger: slide,
                            containerAnimation: scrollTween,
                            scrub: true,
                            start: "left right",
                            end: "right left"
                        }
                    }
                );
            }
        }

         
    });

    // Revolution slide animation
    const revolutionSlide = document.querySelector('.slide--revolution');
    const revolutionImages = document.querySelectorAll('.slide--revolution .slide__revolution-image');
    
    if (revolutionSlide && revolutionImages && revolutionImages.length === 3) {
        // Set initial states for each image
        gsap.set(revolutionImages[0], { autoAlpha: 1, scale: 0.7, rotation: 0, x: "0%" });
        gsap.set(revolutionImages[1], { autoAlpha: 0, scale: 0.8, x: "40%", y: "5%", rotation: 2 });
        gsap.set(revolutionImages[2], { autoAlpha: 0, scale: 0.8, x: "-50%", y: "10%", rotation: 4 });

        // Animate each image separately
        revolutionImages && revolutionImages.forEach((image, index) => {
            gsap.to(image, {
                autoAlpha: 1,
                scale: 1,
                x: index === 0 ? "-20%" : index === 1 ? "-60%" : "40%",
                y: index === 1 ? "10%" : index === 2 ? "20%" : "0%",
                rotation: index === 1 ? -15 : index === 2 ? -9 : index === 0 ? 12 : 0,
                duration: 0.3,
                scrollTrigger: {
                    trigger: revolutionSlide,
                    containerAnimation: scrollTween,
                    start: "left right",
                    end: "right center-=20%",
                    scrub: true,
                    markers: false,
                }
            });
        });
    }

    // Setup date slide animations
    gsap.utils.toArray('.animate-slide').forEach((slide, index) => {
        const dateWrappers = slide.querySelectorAll('.date-slide__date-wrapper');
        const floatingImage = slide.querySelector('.date-slide__floating-image');


            // Map animation
        const map = slide.querySelector('.map');
        if (map) {
            gsap.fromTo(map,
                { scale: 0.8, opacity: 0 }, // Starting state
                {
                    scale: 1,
                    opacity: 1,
                    duration: 1.2,
                    ease: "elastic.out(0.8,0.4)",
                    scrollTrigger: {
                        trigger: map,
                        containerAnimation: scrollTween,
                        start: "left+=40% right",
                        end: "right-=10% left",
                        scrub: false,
                        markers: false,
                        onEnter: () => {
                            gsap.to(map, {
                                scale: 1,
                                opacity: 1,
                                duration: 1.2,
                                ease: "elastic.out(0.8,0.4)"
                            });
                        },
                        onLeave: () => {
                            gsap.to(map, {
                                scale: 0.8,
                                opacity: 0,
                                duration: 1.1,
                                ease: "power4.out"
                            });
                        },
                        onEnterBack: () => {
                            gsap.to(map, {
                                scale: 1,
                                opacity: 1,
                                duration: 1.2,
                                ease: "elastic.out(0.8,0.4)"
                            });
                        },
                        onLeaveBack: () => {
                            gsap.to(map, {
                                scale: 0.8,
                                opacity: 0,
                                duration: 1.1,
                                ease: "power4.out"
                            });
                        }
                    }
                }
            );
        }

        // Boucler sur chaque `date-wrapper` trouvé dans le `slide`
        dateWrappers.forEach((dateWrapper) => {
            // Appliquer l'animation GSAP sur chaque `date-wrapper`
            gsap.to(dateWrapper, {
                rotation: 20,
                duration: 2,
                ease: "none",
                scrollTrigger: {
                    trigger: slide, // Utiliser le slide comme déclencheur de l'animation
                    containerAnimation: scrollTween,
                    start: "left right",
                    end: "right left",
                    scrub: true,
                }
            });

            // Scale animation for visibility
            gsap.fromTo(dateWrapper,
                {
                    scale: 0, // Start from scale 0
                    opacity: 0 // Start from invisible
                },
                {
                    scale: 1, // Scale to 1
                    opacity: 1, // Fade in
                    duration: 0.5, // Duration of the scale animation
                    ease: "bounce.out", // Bounce effect
                    scrollTrigger: {
                        trigger: slide, // Utiliser le slide comme déclencheur de l'animation
                        containerAnimation: scrollTween,
                        start: "left+=50% right",
                        end: "right-=10% left",
                        scrub: false, // Synchronize with scrolling
                        markers: false, 
                        onEnter: () => {
                            // Scale up when entering the viewport
                            gsap.to(dateWrapper, {
                                scale: 1,
                                opacity: 1, // Fade in
                                duration: 1.2,
                                ease: "elastic.out(0.8,0.4)", // Bounce effect
                            });
                        },
                        onLeave: () => {
                            // Scale down when leaving the viewport
                            gsap.to(dateWrapper, {
                                scale: 0,
                                opacity: 0, // Fade out
                                duration: 1.2,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onEnterBack: () => {
                            // Scale up when entering the viewport again
                            gsap.to(dateWrapper, {
                                scale: 1,
                                opacity: 1, // Fade in
                                duration: 1.2,
                                ease: "elastic.out(0.8,0.4)", // Bounce effect
                            });
                        },
                        onLeaveBack: () => {
                            // Scale down when leaving the viewport again
                            gsap.to(dateWrapper, {
                                scale: 0,
                                opacity: 0, // Fade out
                                duration: 1.2,
                                ease: "power4.out" // Smooth transition back
                            });
                        }
                    }
                }
            );
        });

        const lines = slide.querySelectorAll('.date-slide__line path');

        // Loop through each element to apply the animation
        lines.forEach((path) => {

            // Initialize the values of dasharray and dashoffset for each path
            gsap.set(path, {
                strokeDasharray: 1, // Constant value, the total visible path is set to 1
                strokeDashoffset: 3.5, // Hides the stroke by offsetting it by 3
            });

            // Determine the trigger settings based on the parent line class
            const lineContainer = path.closest('.date-slide__line'); // Get the closest line container
            const isLastLine = lineContainer.classList.contains('last'); // Check if it has the class 'last'

            // Set the start and end triggers with percentage offsets
            const startTrigger = isLastLine ? "left right" : "left right"; // Adjust start for the last line
            const endTrigger = isLastLine ? "right-=150% center" : "right center"; // Adjust end for the last line

            // Create a custom ScrollTrigger animation with onUpdate
            ScrollTrigger.create({
                containerAnimation: scrollTween,
                trigger: lineContainer, // Define the trigger container
                start: startTrigger, // Use the determined start trigger
                end: endTrigger, // Use the determined end trigger
                scrub: true, // Synchronize with scrolling
                markers: false, // Enable markers for debugging (optional)
                onUpdate: (self) => {
                    const progressFactor = 1; // Adjust this factor as needed
                    // Calculate the new offset based on self.progress (0 to 1)
                    const newOffset = 3.5 - (self.progress * (3.5 - 2) * progressFactor);
                    // Apply the new value to strokeDashoffset
                    path.style.strokeDashoffset = newOffset;
                }
            });
        });

        // Select the arrows
        const arrows = slide.querySelectorAll('.date-slide__arrow');

        // Loop through each arrow element to apply the animation
        arrows.forEach((path) => {
            // Scale animation for visibility
            gsap.fromTo(path,
                { scale: 0, rotation: -15, opacity: 0 }, // Start from scale 0 and invisible
                {
                    scale: 1, // Scale to 1
                    opacity: 1, // Fade in
                    rotation: 2,
                    duration: 0.5, // Duration of the scale animation
                    ease: "bounce.out", // Bounce effect
                    scrollTrigger: {
                        trigger: path, // Use the arrow container as the trigger
                        containerAnimation: scrollTween,
                        start: "right+=500px right",
                        end: "right-=10px left",
                        scrub: false, // Synchronize with scrolling
                        markers: false,
                        onEnter: () => {
                            // Scale back down when leaving the viewport
                            gsap.to(path, {
                                scale: 1,
                                rotation: 2,
                                opacity: 1, // Fade out
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onLeaveBack: () => {
                            // Scale back down when leaving the viewport
                            gsap.to(path, {
                                scale: 0,
                                rotation: -15,
                                opacity: 0, // Fade out
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onLeave: () => {
                            // Scale back down when leaving the viewport
                            gsap.to(path, {
                                scale: 0,
                                rotation: -15,
                                opacity: 0, // Fade out
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onEnterBack: () => {
                            // Scale back up when entering the viewport again
                            gsap.to(path, {
                                scale: 1,
                                rotation: 2,
                                opacity: 1, // Fade in
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        }
                    }
                }
            );
        });

        // Select the image text elements
        const imageTexts = slide.querySelectorAll('.date-slide__image-text');

        // Loop through each image text element to apply the animation
        imageTexts.forEach((text) => {
            // Scale animation for visibility
            gsap.fromTo(text,
                { scale: 0, rotation: 5, opacity: 0 }, // Start from scale 0 and invisible
                {
                    scale: 1, // Scale to 1
                    opacity: 1, // Fade in
                    rotation: -3,
                    duration: 0.5, // Duration of the scale animation
                    ease: "bounce.out", // Bounce effect
                    scrollTrigger: {
                        trigger: text, // Use the image text container as the trigger
                        containerAnimation: scrollTween,
                        start: "left+=40% right",
                        end: "right-=10% left",
                        scrub: false, // Synchronize with scrolling
                        markers: false,
                        onEnter: () => {
                            // Scale back down when leaving the viewport
                            gsap.to(text, {
                                scale: 1,
                                rotation: -3,
                                opacity: 1, // Fade out
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onLeaveBack: () => {
                            // Scale back down when leaving the viewport
                            gsap.to(text, {
                                scale: 0,
                                rotation: 5,
                                opacity: 0, // Fade out
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onLeave: () => {
                            // Scale back down when leaving the viewport
                            gsap.to(text, {
                                scale: 0,
                                rotation: 5,
                                opacity: 0, // Fade out
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onEnterBack: () => {
                            // Scale back up when entering the viewport again
                            gsap.to(text, {
                                scale: 1,
                                rotation: -3,
                                opacity: 1, // Fade in
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        }
                    }
                }
            );
        });

        if (floatingImage) {
            // Existing vertical movement with yoyo
            // Create a timeline for a more organic floating effect
            const tl = gsap.timeline({
                repeat: -1, // Repeat indefinitely
                yoyo: true // Reverse the animation on repeat
            });

            // Add multiple tweens to create an organic floating effect
            tl.to(floatingImage, {
                y: "6%",
                duration: 4.5,
                ease: "sine.inOut",
            })
                .to(floatingImage, {
                    y: "-5%", // Slightly less than the first movement
                    duration: 3.5, // Vary the duration for a more organic feel
                    ease: "sine.inOut",
                })
                .to(floatingImage, {
                    y: "8%", // Move higher for the next part of the animation
                    duration: 4, // Longer duration for a smoother transition
                    ease: "sine.inOut",
                })
                .to(floatingImage, {
                    y: "-5%", // Return to the original position
                    duration: 4.5,
                    ease: "sine.inOut",
                });

            // Create a separate ScrollTrigger for rotation
            gsap.fromTo(floatingImage, {
                rotation: -35 // Start rotation
            }, {
                rotation: 8, // End rotation
                ease: "power2.out",
                scrollTrigger: {
                    trigger: slide, // Use the slide as the trigger for rotation
                    containerAnimation: scrollTween,
                    scrub: true, // Enable scrubbing
                    start: "left right",
                    end: "right left",
                }
            });

            // New ScrollTrigger for floatingImage
            gsap.fromTo(floatingImage, {
                scale: 0,
                opacity: 0 // Start fully transparent
            }, {
                scale: 1,
                opacity: 1, // Fade in to fully visible
                duration: 1.3, // Duration of the fade
                scrollTrigger: {
                    trigger: floatingImage, // Use floatingImage as the trigger
                    containerAnimation: scrollTween,
                    start: "left+=10% right",
                    end: "right-=10% left",
                    scrub: false, // Enable scrubbing for smooth transition
                    markers: false, // Enable markers for debugging (optional)
                    onEnter: () => {
                        // Actions when the trigger enters the viewport
                        gsap.to(floatingImage, {
                            scale: 1,
                            opacity: 1, // Ensure it is fully visible
                            duration: 1.3,
                            ease: "elastic.out(0.8,0.4)", // Bounce effect
                        });
                    },
                    onLeave: () => {
                        // Actions when the trigger leaves the viewport
                        gsap.to(floatingImage, {
                            scale: 0,
                            opacity: 0, // Fade out
                            duration: 0.7,
                            ease: "power2.out"
                        });
                    },
                    onEnterBack: () => {
                        // Actions when the trigger re-enters the viewport from below
                        gsap.to(floatingImage, {
                            scale: 1,
                            opacity: 1, // Fade in again
                            duration: 1.3,
                            ease: "elastic.out(0.8,0.4)", // Bounce effect
                        });
                    },
                    onLeaveBack: () => {
                        // Actions when the trigger leaves the viewport going back up
                        gsap.to(floatingImage, {
                            scale: 0,
                            opacity: 0, // Fade out
                            duration: 0.7,
                            ease: "power2.out"
                        });
                    }
                }
            });
        }
    });
}







/*
**
** Animation Mobile
**
*/

function setupMobileAnimations() {
    // Select the displacement element
    const displacementElement = document.querySelector('.displacement');

    // Vertical scroll-based animation for the 'r' attribute
    gsap.fromTo(displacementElement,
        { r: 20 },
        {
            r: 115,
            duration: 6,
            ease: 'power3.inOut',
            scrollTrigger: {
                trigger: displacementElement,
                scrub: true,
                start: "top bottom",
                end: "center+=100px top",
                markers: false
            }
        }
    );

    // Select menu items for the sticky menu animation
    const anchorItems = document.querySelectorAll('.sticky-menu li');
    gsap.fromTo(anchorItems,
        { y: "-100%", scale: 0.8, opacity: 0 },
        {
            y: 0,
            opacity: 1,
            scale: 1,
            duration: 0.5,
            stagger: 0.09,
            ease: "power4.out",
            scrollTrigger: {
                trigger: document.querySelector('.sticky-menu'),
                start: "top+=300px bottom",
                end: "bottom+=300px top",
                markers: false,
                onEnter: () => gsap.to(anchorItems, {
                    y: 0, opacity: 1, scale: 1, stagger: 0.09, ease: "power4.out"
                }),
                onLeaveBack: () => gsap.to(anchorItems, {
                    y: "-100%", opacity: 0, scale: 0.8, ease: "power4.out"
                })
            }
        }
    );

    // Animations for each slide
    gsap.utils.toArray('.animate-slide').forEach((slide) => {
        const title = slide.querySelector('.slide__title');  // Removed [data-splitting]
        const textElement = slide.querySelector('.slide__text');
        const textDateElements = slide.querySelectorAll('.date-slide__text');
        const dash = slide.querySelector('.slide__dash');

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: slide,
                start: "top bottom",
                end: "bottom top",
                toggleActions: "play none none reverse",
                fastScrollEnd: true,
            }
        });

        // Title animation (by words)
        if (title) {

            Splitting({ target: title, by: 'words' });

            // Récupérer tous les mots générés par Splitting.js
            const titleText = title.querySelectorAll('span.word'); // Splitting.js utilise `span.word` pour les mots

            tl.from(titleText, { y: '100%', opacity: 0, rotate: 5, stagger: 0.03, duration: 0.95, ease: 'power4.out' })
                .to(titleText, { rotate: 0, duration: 0.95, ease: 'power2.out' }, 0.3);
        }

        // Text description animation individuelle
        if (textElement) {
            gsap.from(textElement, {
                opacity: 0,
                y: 20,
                duration: 0.95,
                ease: 'expo.out',
                scrollTrigger: {
                    trigger: textElement,
                    start: "top center+=100",
                    end: "bottom top",
                    toggleActions: "play none none reverse"
                }
            });
        }

        // Animation individuelle pour chaque textDateElement
        textDateElements.forEach((textDateElement) => {
            gsap.from(textDateElement, {
                opacity: 0,
                y: 20,
                duration: 0.95,
                ease: 'power4.out',
                scrollTrigger: {
                    trigger: textDateElement,
                    start: "top center+=100",
                    end: "bottom top",
                    toggleActions: "play none none reverse"
                }
            });
        });
        
        // Dash animation
        if (dash) {
            tl.from(dash, { width: 0, duration: 1 }, 0);
        }

        // Parallax effect for images
        const imageInner = slide.querySelector('.slide__image-inner');
        if (imageInner) {
            gsap.fromTo(imageInner,
                { y: -50, scale: 1 },
                {
                    y: 50, scale: 1.2, ease: "none",
                    scrollTrigger: { trigger: slide, scrub: true, start: "top bottom", end: "bottom top" }
                }
            );
        }

        // Select the arrows
        const arrows = slide.querySelectorAll('.date-slide__arrow');

        // Loop through each arrow element to apply the animation
        arrows.forEach((path) => {
            // Scale animation for visibility
            gsap.fromTo(path,
                { scale: 0, rotation: -15, opacity: 0 }, // Start from scale 0 and invisible
                {
                    scale: 1, // Scale to 1
                    opacity: 1, // Fade in
                    rotation: 2,
                    duration: 0.5, // Duration of the scale animation
                    ease: "bounce.out", // Bounce effect
                    scrollTrigger: {
                        trigger: path, // Use the arrow container as the trigger
                        start: "bottom+=120px bottom",
                        end: "bottom+=300px top",
                        scrub: false, // Synchronize with scrolling
                        markers: false,
                        onEnter: () => {
                            // Scale back down when leaving the viewport
                            gsap.to(path, {
                                scale: 1,
                                rotation: 2,
                                opacity: 1, // Fade out
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onLeaveBack: () => {
                            // Scale back down when leaving the viewport
                            gsap.to(path, {
                                scale: 0,
                                rotation: -15,
                                opacity: 0, // Fade out
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onLeave: () => {
                            // Scale back down when leaving the viewport
                            gsap.to(path, {
                                scale: 0,
                                rotation: -15,
                                opacity: 0, // Fade out
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onEnterBack: () => {
                            // Scale back up when entering the viewport again
                            gsap.to(path, {
                                scale: 1,
                                rotation: 2,
                                opacity: 1, // Fade in
                                duration: 1.1,
                                ease: "power4.out" // Smooth transition back
                            });
                        }
                    }
                }
            );
        });
    });
    

    // Revolution slide animation
    const revolutionSlide = document.querySelector('.slide--revolution');
    const revolutionImages = revolutionSlide.querySelectorAll('.slide__revolution-image');
    if (revolutionSlide && revolutionImages.length === 3) {
        gsap.set(revolutionImages[0], { autoAlpha: 1, scale: 0.7, rotation: 0, x: "0%" });
        gsap.set(revolutionImages[1], { autoAlpha: 0, scale: 0.8, x: "40%", y: "5%", rotation: 2 });
        gsap.set(revolutionImages[2], { autoAlpha: 0, scale: 0.8, x: "-50%", y: "10%", rotation: 4 });

        revolutionImages.forEach((image, index) => {
            gsap.to(image, {
                autoAlpha: 1,
                scale: 1,
                x: index === 0 ? "0" : index === 1 ? "-55%" : "30%",
                y: index === 1 ? "10%" : index === 2 ? "22%" : "0%",
                rotation: index === 1 ? -15 : index === 2 ? 9 : 0,
                duration: 0.3,
                scrollTrigger: { trigger: revolutionSlide, start: "top bottom", end: "center top", scrub: true }
            });
        });
    }

    // Date slide elements (date wrappers, lines, arrows, and floating images)
    gsap.utils.toArray('.animate-slide').forEach((slide) => {
        const dateWrappers = slide.querySelectorAll('.date-slide__date-wrapper');
        const floatingImage = slide.querySelector('.date-slide__floating-image');

         // Boucler sur chaque `date-wrapper` trouvé dans le `slide`
         dateWrappers.forEach((dateWrapper) => {
            // Appliquer l'animation GSAP sur chaque `date-wrapper`
            gsap.to(dateWrapper, {
                rotation: 20, duration: 2, ease: "none",
                scrollTrigger: { trigger: slide, start: "top bottom", end: "bottom top", scrub: true }
            });

            // Scale animation for visibility
            gsap.fromTo(dateWrapper,
                {
                    scale: 0, // Start from scale 0
                    opacity: 0 // Start from invisible
                },
                {
                    scale: 1, // Scale to 1
                    opacity: 1, // Fade in
                    duration: 0.5, // Duration of the scale animation
                    ease: "bounce.out", // Bounce effect
                    scrollTrigger: {
                        trigger: slide, // Utiliser le slide comme déclencheur de l'animation
                        start: "top bottom",
                        end: "bottom top",
                        scrub: false, // Synchronize with scrolling
                        onEnter: () => {
                            // Scale up when entering the viewport
                            gsap.to(dateWrapper, {
                                scale: 1,
                                opacity: 1, // Fade in
                                duration: 1.2,
                                ease: "elastic.out(0.8,0.4)", // Bounce effect
                            });
                        },
                        onLeave: () => {
                            // Scale down when leaving the viewport
                            gsap.to(dateWrapper, {
                                scale: 0,
                                opacity: 0, // Fade out
                                duration: 1.2,
                                ease: "power4.out" // Smooth transition back
                            });
                        },
                        onEnterBack: () => {
                            // Scale up when entering the viewport again
                            gsap.to(dateWrapper, {
                                scale: 1,
                                opacity: 1, // Fade in
                                duration: 1.2,
                                ease: "elastic.out(0.8,0.4)", // Bounce effect
                            });
                        },
                        onLeaveBack: () => {
                            // Scale down when leaving the viewport again
                            gsap.to(dateWrapper, {
                                scale: 0,
                                opacity: 0, // Fade out
                                duration: 1.2,
                                ease: "power4.out" // Smooth transition back
                            });
                        }
                    }
                }
            );
        });

        const lines = slide.querySelectorAll('.date-slide__line path');
        lines.forEach((path) => {
            gsap.set(path, { strokeDasharray: 1, strokeDashoffset: 3 });
            ScrollTrigger.create({
                trigger: path.closest('.date-slide__line'),
                start: "top+=100px bottom", 
                end: "bottom top+=120px", 
                scrub: true,
                onUpdate: (self) => path.style.strokeDashoffset = 3 - (self.progress * 1)
            });
        });

        // Floating image animation
        if (floatingImage) {
            // Set initial state
            gsap.set(floatingImage, {
                scale: 0,
                opacity: 0,
                rotation: -35
            });

            // Animation de rotation continue
            gsap.fromTo(floatingImage, 
                { rotation: -35 }, 
                {
                    rotation: 8,
                    ease: "power2.out",
                    scrollTrigger: { 
                        trigger: slide, 
                        scrub: true, 
                        start: "top bottom",
                        end: "bottom top" 
                    }
                }
            );

            // Animation d'apparition/disparition améliorée
            ScrollTrigger.create({
                trigger: floatingImage,
                start: "top bottom-=00",
                end: "bottom top+=00",
                toggleActions: "play reverse play reverse",
                onEnter: () => {
                    gsap.to(floatingImage, {
                        scale: 1,
                        opacity: 1,
                        duration: 1.3,
                        ease: "elastic.out(0.8,0.4)",
                        overwrite: true
                    });
                },
                onLeave: () => {
                    gsap.to(floatingImage, {
                        scale: 0,
                        opacity: 0,
                        duration: 0.7,
                        ease: "power2.out",
                        overwrite: true
                    });
                },
                onEnterBack: () => {
                    gsap.to(floatingImage, {
                        scale: 1,
                        opacity: 1,
                        duration: 1.3,
                        ease: "elastic.out(0.8,0.4)",
                        overwrite: true
                    });
                },
                onLeaveBack: () => {
                    gsap.to(floatingImage, {
                        scale: 0,
                        opacity: 0,
                        duration: 0.7,
                        ease: "power2.out",
                        overwrite: true
                    });
                }
            });
        }
    });
}
